module.exports = __webpack_public_path__ + "img/star.fd15fe26.svg";